<template >
    <aside >
        <v-card >  
            <v-navigation-drawer 
                app
                clipped
                v-model="drawer"
            >
                <v-divider></v-divider>
                <v-list
                    dense
                    nav
                >
                    <v-list-item
                        v-for="(menuItem, index) in menuItems" 
                        :key="index"
                        :to="menuItem.url"
                    >
                        <v-list-item-content>
                            <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </v-card>
    </aside>
</template>

<script>
import constants from '../common/constants'

export default {
    name: 'AppSidemenu',
    data() {
        return {
            menuItems: constants.menuItems,
            drawer: null,
        }
    },
}
</script>

